import React from "react";
import SeoArticlePage from "../components/SeoArticlePage";
import Pricing from "../components/landing/Pricing";

export default function Tarifs() {
  return (
    <SeoArticlePage
      seo={{
        title: "Tarifs 360immoinvest : gestion locative en ligne, du gratuit au Pro",
        description:
          "Découvrez les formules 360immoinvest : Gratuit pour 1 bien, Premium et Pro. Quittances, suivi des loyers, révision IRL et revenus fonciers. Sans engagement.",
        path: "/tarifs",
        testid: "tarifs-page",
      }}
      eyebrow="Tarifs"
      h1="Un prix pour chaque bailleur"
      intro="Commencez gratuitement avec un bien, puis passez à Premium ou Pro quand votre patrimoine grandit. Pas de carte bancaire pour démarrer, aucun engagement, et vous changez de formule à tout moment."
      sections={[
        {
          title: "Ce que comprend chaque formule",
          paragraphs: [
            "Toutes les formules incluent l'essentiel de la gestion locative : suivi des loyers et des charges, génération et envoi des quittances, révision de loyer avec l'IRL et aide à la déclaration des revenus fonciers.",
            "Les formules Premium et Pro ajoutent la gestion de plusieurs biens, des fonctionnalités avancées (comptabilité, régularisation des charges, assistant IA) et la délégation à un référent local pour vos états des lieux.",
          ],
        },
        {
          title: "Pourquoi une offre gratuite ?",
          paragraphs: [
            "Nous voulons que chaque bailleur puisse gérer son premier logement sereinement, sans frais. L'offre Gratuite est complète pour un bien : vous générez vos quittances, suivez vos paiements et préparez votre déclaration sans dépenser un euro.",
          ],
        },
        {
          title: "Changer ou résilier à tout moment",
          paragraphs: [
            "Vous montez de formule en un clic lorsque vous ajoutez des biens, et vous revenez à une formule inférieure quand vous le souhaitez. La résiliation se fait depuis votre espace, sans démarche compliquée ni pénalité.",
          ],
        },
      ]}
      faq={[
        { q: "L'offre gratuite est-elle vraiment gratuite ?", a: "Oui. La formule Gratuite vous permet de gérer un bien avec les fonctions essentielles, sans carte bancaire et sans limite de durée." },
        { q: "Puis-je changer de formule plus tard ?", a: "Bien sûr. Vous pouvez passer à Premium ou Pro à tout moment, et revenir à une formule inférieure quand vous le souhaitez." },
        { q: "Dois-je saisir une carte bancaire pour commencer ?", a: "Non, la création de compte et l'offre Gratuite ne demandent aucune carte bancaire. Elle n'est requise que pour souscrire une formule payante." },
        { q: "Comment résilier ?", a: "La résiliation se fait directement depuis votre espace « Mon abonnement », sans engagement ni frais cachés." },
      ]}
      related={[
        { to: "/quittance-de-loyer", label: "Quittance de loyer" },
        { to: "/revision-loyer-irl", label: "Révision de loyer (IRL)" },
        { to: "/declaration-revenus-fonciers", label: "Revenus fonciers" },
      ]}
    >
      <Pricing />
    </SeoArticlePage>
  );
}
